export default "__VITE_ASSET__D_8G9thb__"